export default "__VITE_ASSET__Cxw9BOxW__"